import { render, staticRenderFns } from "./GlobalProviderSpotlight.vue?vue&type=template&id=17c4d136&scoped=true"
import script from "./GlobalProviderSpotlight.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalProviderSpotlight.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalProviderSpotlight.vue?vue&type=style&index=0&id=17c4d136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c4d136",
  null
  
)

export default component.exports